import { Flex, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { Text } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import ClockIcon from '@atlaskit/icon/core/clock';

import { CalendarDate } from 'src/components/CalendarDate';

interface ClassTimeSlotProps {
  iconMonth: string;
  iconDay: string;
  titleDate: string;
  subtitleTime: string;
}

export const ClassTimeSlot = ({ iconMonth, iconDay, titleDate, subtitleTime }: ClassTimeSlotProps) => {
  return (
    <div css={containerStyles}>
      <CalendarDate monthString={iconMonth} dayString={iconDay} />
      <Stack space="space.050" alignInline="start">
        <Flex alignItems="center" gap="space.050">
          <ClockIcon label="clock" color={token('color.text.brand')} />
          <Text>{subtitleTime}</Text>
        </Flex>
        <Text size="regular" fontWeight="regular" color={token('color.text.subtle')}>
          {titleDate}
        </Text>
      </Stack>
    </div>
  );
};

const containerStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: token('space.200'),
  flexWrap: 'nowrap',
});
